
$(document).ready(function () {
	$('.js-carousel.arrows-dots').each(function () {
		var slickInduvidual = $(this);
		if (slickInduvidual.length) {
			slickInduvidual.slick({
				dots: true,
				slidesToShow: 1,
				slide: '.carousel-offset-item',
				arrows: true,
				nextArrow: '<span class="fal fa-long-arrow-right"></span>',
				prevArrow: '<span class="fal fa-long-arrow-left"></span>', 
				appendArrows: $(this).find('.carousel-offset-arrows')
			});
		}
	});


	$('.js-carousel.only-arrows').each(function () {
		var slickInduvidual = $(this);
		if (slickInduvidual.length) {
			slickInduvidual.slick({
				dots: false,
				slidesToShow: 1,
				slide: '.carousel-offset-item',
				arrows: true,
				nextArrow: '<span class="fal fa-long-arrow-right"></span>',
				prevArrow: '<span class="fal fa-long-arrow-left"></span>', 
				appendArrows: $(this).find('.carousel-offset-arrows')
			});
		}
	});

	$('.js-carousel.event-carousel').each(function () {
		var slickInduvidual = $(this);
		if (slickInduvidual.length) {
			slickInduvidual.slick({
				dots: false,
				slidesToShow: 1,
				adaptiveHeight: true,
				slide: '.carousel-offset-item',
				arrows: true,
				nextArrow: '<span class="fal fa-long-arrow-right"></span>',
				prevArrow: '<span class="fal fa-long-arrow-left"></span>',
				appendArrows: $(this).find('.carousel-offset-arrows')
			});
		}
	});

	$('.watchlist-carousel .row').slick({
		dots: false,
		slidesToShow: 3,
		slidesToScroll: 2,
		adaptiveHeight: false,
		slide: '.watchlist-slide',
		arrows: true,
		nextArrow: '<span class="fal fa-long-arrow-right"></span>',
		prevArrow: '<span class="fal fa-long-arrow-left"></span>',
		appendArrows: $('.arrows'),
		variableWidth: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2
				}
			},
		]
	});

	$('.watchlist-carousel').each(function () {
		var slickInduvidual = $(this);
		if (slickInduvidual.length) {
			slickInduvidual.slick({
				dots: false,
				adaptiveHeight: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: false,
				slide: '.watchlist-carousel-item',
				arrows: true,
				nextArrow: '<span class="fal fa-long-arrow-right"></span>',
				prevArrow: '<span class="fal fa-long-arrow-left"></span>',
				appendArrows: $(this).find('.watchlist-carousel-arrows'),
				responsive: [
					{
						breakpoint: 960,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});
		}
	});
});